// @flow
import {getSignedUrl as getSignedUrlAPI} from 'api/admin'
import I18n from 'I18n'
import {NotificationManager} from 'modules/Common/components/Notification'

export const getSignedUrl = (file: any, callback: Function) => {
  getSignedUrlAPI(JSON.stringify({contentType: file.type})).then(data => {
    callback({
      ...data,
      signedUrl: data.url
    })
  })
}

export const preProcessUploadAvatar = (file: any, next: Function) => {
  if (file.size > 2 * 1024 * 1024) {
    NotificationManager.error(I18n.admin.uploadLogoError.error1)
  } else {
    next(file)
  }
}

export const parseAttributes = (attributes: Array<any>) => {
  const result = {}
  attributes &&
    attributes.forEach(attr => {
      result[attr.name] = attr.value
    })

  return result
}

export const ATTRIBUTES = {
  '2faWecomBanner': 'com.leapxpert.client.2fa.wecom.banner_url'
}

export const parseCompanyData = (companyInfo: any) => {
  if (!companyInfo) return {}
  if (typeof companyInfo !== 'object') return {}

  let result = {...companyInfo, '2faWecomBanner': ''}

  if (result.attributes) {
    const matched2FaWecomBannerAttribute = result.attributes.find((attr) => attr.name === ATTRIBUTES['2faWecomBanner'])
    if (matched2FaWecomBannerAttribute) {
      result['2faWecomBanner'] = matched2FaWecomBannerAttribute.value
    }
  }

  return result
}